<div *ngIf="currentStep === 1">
  <ng-container
    *ngIf="tenderType === 'consultancy services'; else constructionWork"
  >
    <app-rfq-consultancy-services
    [rfpResponseData]="tendererResponse"
    [tendererResponseData] = tendererResponseData
    (consultancyServiceDataEmitter)="handleConsultancyServiceEmittedData($event)"
    ></app-rfq-consultancy-services>
  </ng-container>

  <ng-template #constructionWork>
    <app-rfq-construction-work
    [rfpResponseData]="tendererResponse"
    [tendererResponseData] = tendererResponseData
    (constructionWorksDataEmitter)="handleConstructionWorksEmittedData($event)"
    ></app-rfq-construction-work>
  </ng-template>
</div>

<div *ngIf="currentStep === 2">
  <app-rfq-technical-submission
  [rfpResponseData]="tendererResponse"
  [tendererResponseData] = tendererResponseData
  (technicalSubmissionDataEmitter)="handleTechnicalSubmissionEmittedData($event)"
  ></app-rfq-technical-submission>
</div>

<div *ngIf="currentStep === 3">
  <app-rfq-commercial-submission
  [rfpResponseData]="tendererResponse"
  [tendererResponseData] = tendererResponseData
  (commercialSubmissionDataEmitter)="handleCommercialSubmissionEmittedData($event)"
  ></app-rfq-commercial-submission>
</div>

<div *ngIf="currentStep === 4">
  <app-rfq-conclusion
    [rfpResponseData]="tendererResponse"
    [tendererResponseData] = tendererResponseData
    (closeModalEvent)="handleCloseModal($event)"
    >
  </app-rfq-conclusion>
</div>
